/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Button, Spacer, ExpandCollapse, Typography } from '@telus-uds/components-web';
import { Box } from '../design/css';
import 'react-datepicker/dist/react-datepicker.css';
import './styles.css';
import {
  PROVINCE_MULTISELECT_OPTIONS,
  renderDashboardMultiSelectRows,
  renderDashboardDualDateRangeFilters
} from './components';

const FMSOWFilters = ({
  data,
  updateFilters,
  onApplyFilters,
  onResetFilters,
  filterState,
  staticLabels,
  isMyOrder
}) => {
  const {
    startDate,
    endDate,
    completedStartDate,
    completedEndDate,
    channelId,
    province,
    status,
    submitter
  } = filterState;
  const {
    filterByChannel,
    filterByProvince,
    filterByStatus,
    filterBySubmitter,
    filterByOpenedDates,
    filterByValidationDates,
    startDateLabel,
    endDateLabel,
    buttonApply,
    buttonReset,
    filtersDropdownTitle
  } = staticLabels;
  let { channels, statuses, submitters } = data;
  const channelList =
    channels &&
    channels.map(channel => ({ label: channel.text, value: channel.value }));
  if (!isMyOrder) statuses = statuses.slice(2);
  const statusList =
    statuses &&
    statuses.map(statusdata => ({
      label: statusdata.text,
      value: statusdata.value
    }));

  let multiSelectFilters = [
    {
      label: filterByProvince,
      name: 'province',
      options: PROVINCE_MULTISELECT_OPTIONS,
      value: province
    },
    {
      label: filterByChannel,
      name: 'channelId',
      options: channelList,
      value: channelId
    },
    {
      label: filterByStatus,
      name: 'status',
      options: statusList,
      value: status
    },
    {
      label: filterBySubmitter,
      name: 'submitter',
      options: (submitters || []).map(op => ({
        value: op.id,
        label: `${op.firstName} ${op.lastName} , (${op.email})`
      })),
      value: submitter
    }
  ];

  if (isMyOrder)
    multiSelectFilters = multiSelectFilters.filter(
      filter => filter.name !== 'submitter' && filter.name !== 'channelId'
    );

  return (
    <ExpandCollapse initialOpen={[]}>
      {(expandProps) => (
        <ExpandCollapse.Panel
          {...expandProps}
          panelId="filters"
          control={<Typography variant={{ bold: true }}>{filtersDropdownTitle}</Typography>}
        >
          <div className="row">
            {renderDashboardDualDateRangeFilters({
              updateFilters,
              filterByOpenedDates,
              filterByValidationDates,
              startDateLabel,
              endDateLabel,
              startDate,
              endDate,
              completedStartDate,
              completedEndDate
            })}
            {renderDashboardMultiSelectRows(multiSelectFilters, updateFilters, {
              transformValue: ({ name, value }) =>
                name === 'submitter' && Array.isArray(value)
                  ? value.map(item => ({
                      ...item,
                      label: item.label.split(' , ')[0]
                    }))
                  : value
            })}
          </div>

          <Spacer space={3} />
          <Box display="flex" justifyContent="center" flexDirection="row">
            <Button onClick={onApplyFilters} variant={{ priority: 'low' }}>
              {buttonApply}
            </Button>
            <Box width="2"> </Box>
            <Button onClick={onResetFilters}>{buttonReset}</Button>
          </Box>
        </ExpandCollapse.Panel>
      )}
    </ExpandCollapse>
  );
};

export default FMSOWFilters;

FMSOWFilters.propTypes = {
  staticLabels: PropTypes.object.isRequired,
  onApplyFilters: PropTypes.func.isRequired,
  onResetFilters: PropTypes.func.isRequired,
  updateFilters: PropTypes.func.isRequired,
  filterState: PropTypes.shape({
    filterStatus: PropTypes.string,
    startDate: PropTypes.dateFormat,
    endDate: PropTypes.dateFormat,
    completedStartDate: PropTypes.dateFormat,
    completedEndDate: PropTypes.dateFormat,
    submitter: PropTypes.array,
    status: PropTypes.array,
    channelId: PropTypes.array,
    province: PropTypes.array,
    productId: PropTypes.array
  }).isRequired,
  data: PropTypes.arrayOf(PropTypes.object).isRequired
};
